export enum Language {
  EN = "EN",
  SV = "SV",
  FI = "FI",
}
